/*=====================
      Color Picker
==========================*/
var color_picker1 = document.getElementById("colorPick").value;
document.getElementById("colorPick").onchange = function () {
    color_picker1 = this.value;
    document.body.style.setProperty("--theme-color", color_picker1);
    document.body.style.setProperty("--theme-color-rgb", color_picker1);
};

/*========================
 Dark setting js
 ==========================*/

$(document).ready(function () {
  var currentMode = localStorage.getItem("mode");
  if (currentMode === "dark") {
    enableDarkMode();
  } else {
    enableLightMode();
  }

  $("#darkButton").on("click", function () {
    enableDarkMode();
  });

  $("#lightButton").on("click", function () {
    enableLightMode();
  });

  function enableDarkMode() {
    $("body").removeClass("light");
    $("body").addClass("dark");
    document
      .getElementById("color-link")
      .setAttribute("href", "//khati.co.uk/cdn/shop/t/26/assets/style_dark.css?v=103224456346737919541791964531");
    localStorage.setItem("mode", "dark");
  }

  function enableLightMode() {
    $("body").removeClass("dark");
    $("body").addClass("light");
    document
      .getElementById("color-link")
      .setAttribute("href", "//khati.co.uk/cdn/shop/t/26/assets/style.css?v=88794987872067223221792944671");
    localStorage.setItem("mode", "light"); 
  }
});

/*========================
   RTL setting js
   ==========================*/
$(".rtl").on("click", function () {
    if ($("body").hasClass("ltr")) {
        $("html").attr("dir", "rtl");
        $("body").removeClass("ltr");
        $("body").addClass("rtl");
        $("#rtl-link").attr("href", "//khati.co.uk/cdn/shop/t/26/assets/bootstrap.rtl.css?v=118328639634488397631791964459");
    } else {
        $("html").attr("dir", "");
        $("body").removeClass("rtl");
        $("body").addClass("ltr");
        $("#rtl-link").attr("href", "//khati.co.uk/cdn/shop/t/26/assets/bootstrap.css?v=135319724603103446941791964459");
    }
});